<sq-loading-bar [active]="loading"></sq-loading-bar>
<div class="d-flex flex-column {{iframeClass}}" [ngStyle]="{'height.%': 100}">
    <sq-preview-document-iframe
        [sandbox]="sandbox"
        [downloadUrl]="downloadUrl"
        [scalingFactor]="scalingFactor"
        (onPreviewReady)="onPreviewReady($event)">
    </sq-preview-document-iframe>

</div>